export default __webpack_public_path__ + "static/media/d66.71bb056e.jpg";